import config from "config";
import dayjs from "utils/dayjs";
import { LOG_LEVEL } from "constants/LogConstants";
import { getBusinessUnit, getUsername, getToken } from "utils/Common";
import { handleError } from "react-error-boundary";
import { UserBU } from "constants/UserConstants";
import { uepClient } from "uepClient";

export const logError = async (error, user) => {
  const message = buildErrorMessage(error);
  console.error(message);
  logToServer(message, LOG_LEVEL.ERROR, user);
};

export const buildErrorMessage = (error) => {
  let message = "";
  if (!error) {
    return message;
  }

  if (error.response) {
    message =
      "Request " +
      error.response.config?.url +
      ", params:" +
      JSON.stringify(error.response.config?.params) +
      " failed, status:" +
      error.response.status;
  } else {
    message = error.message;

    if (error.stack) {
      message += " sourceFunction:" + error.stack.split("\n")[1];
    }
    if (error.config) {
      message += " request: " + error.config.method + " " + error.config.url;
    }
  }
  return message;
};

export const logToServer = (message, logLevel, user = null) => {
  const businessUnit = getBusinessUnit();
  let source = "UEP_PORTAL";
  if (businessUnit === UserBU.CV) {
    source = "UEP_CV_PORTAL";
  }
  return uepClient().post(
    `/logs/capture`,
    {
      username: user,
      message: message,
      logLevel: logLevel,
      logTime: dayjs().utc().toISOString(),
      source: source,
    },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const createLogOverrides = () => {
  const oldConsole = window.console;
  const newConsoleWithLogging = {
    ...oldConsole,
    info: function (message, ...options) {
      oldConsole.info(message, ...options);
      logToServer(
        formattedMessage(message, ...options),
        LOG_LEVEL.INFO,
        getUsername()
      );
    },
    warn: function (originalMessage, ...options) {
      oldConsole.warn(originalMessage, ...options);
      const message = buildWarningMessage(originalMessage);
      logToServer(message, LOG_LEVEL.WARN, getUsername());
    },
    error: function (message, ...options) {
      oldConsole.error(message, ...options);
      if (typeof message === "string" && message.indexOf("Warning") === 0) {
        console.warn(message, ...options);
      } else {
        logToServer(
          formattedMessage(message, ...options),
          LOG_LEVEL.ERROR,
          getUsername()
        );
      }
    },
  };
  window.console = newConsoleWithLogging;
  window.onerror = (message, error) => {
    if (error.stack) {
      let sourceFunction = error.stack.split("\n")[1];
      handleError(new Error(message + sourceFunction));
    } else {
      handleError(error);
    }
  };
};

const formattedMessage = (message, ...options) => {
  const formattedMessage = `${message}, ${options.join(", ")}`;
  return formattedMessage;
};

const buildWarningMessage = (originalMessage) => {
  const traceArray = originalMessage.split("\n");
  let newMessage = traceArray[0];
  let sourceFunctionCount = 0;
  for (let i = 1; sourceFunctionCount < 3 && i < traceArray.length; i++) {
    if (traceArray[i].includes("at")) {
      newMessage += "\n" + traceArray[i];
      sourceFunctionCount++;
    }
  }
  return newMessage;
};
